import { useMemo } from 'react';

import { useSelectionData } from './useSelectionData';

export const useAllOfferImages = () => {
  const { offers } = useSelectionData();

  const allOfferImagesSet = useMemo(() => {
    return new Set([
      ...offers.flatMap(offer => {
        if (offer.images && offer.images.length > 0) {
          return offer.images.map(image => image.url);
        }
        return [];
      }),
    ]);
  }, [offers]);

  return {
    allOfferImagesSet,
  };
};
